'use client'

import useEmblaCarousel from 'embla-carousel-react'
import Image from 'next/image'
import Link from 'next/link'

import { DotButton, useDotButton } from '@/hooks/useEmblaDot'
import { loadImage } from '@/lib/utils'
import { BrandSupplier } from '@/types/brand.type'

import styles from '~/public/assets/css/product/supplier.module.css'

type SupplierCarouselProps = {
  suppliers: BrandSupplier[]
}

export default function SupplierCarousel({ suppliers }: SupplierCarouselProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ align: 'center', slidesToScroll: 'auto', duration: 50 })
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)
  return (
    <div className={styles.embla}>
      <div className={styles.embla__viewport} ref={emblaRef}>
        <div className={styles.embla__container}>
          {suppliers.map((item, index) => {
            return (
              <div className={styles.embla__slide} key={index}>
                <Link prefetch={false} href={`/thuong-hieu/${item.slug}`} target="_blank" className="block border hover:border-primary">
                  <Image src={loadImage('medium', item.image_id)} alt={item.name} width={0} height={0} priority sizes="100vw" className="w-full h-[60px] object-contain" />
                </Link>
              </div>
            )
          })}
        </div>
      </div>

      <div className={styles.embla__controls}>
        <div className={styles.embla__dots}>
          {scrollSnaps.map((_, index) => (
            <DotButton key={index} onClick={() => onDotButtonClick(index)} className={`${styles.embla__dot} ${index === selectedIndex ? styles['embla__dot--selected'] : ''}`} />
          ))}
        </div>
      </div>
    </div>
  )
}
